import { Spin } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Table, { ColumnsType } from 'antd/es/table';
import ProductApi from 'apis/ProductApi';
import {
  EyeIcon,
  UploadIcon,
  MoreOption,
  EditIcon,
  Edit3Icon,
} from 'assets/svg';
import Button from 'components/Button';
import { PRODUCT_POF_STATUS, PRODUCT_STATUS } from 'constants/productStatus';
import { IProduct } from 'interface/product.interface';
import { useMutation } from 'react-query';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import formatCurrencyVND from 'utils/formatCurrencyVND';
import useQueryParam from 'hooks/useQueryPrams';
import { HocChangePagination } from 'utils/HocChangePagination';
import { useHistory } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { Dropdown, Space } from 'antd';
import { cancelDropdown, editDropdown, moveDropdown } from 'assets/images';
import { openNotificationWithIcon } from 'utils/notification';
import { useState } from 'react';

interface IProps {
  pof_code: string;
  pof_type_code: string;
  products: IProduct[];
  total: number;
  isLoading: boolean;
  onReloadProducts: () => void;
  onUpdateProducts: () => void;
}

export default function Product(props: IProps): JSX.Element {
  const {
    pof_code,
    pof_type_code,
    products,
    total,
    isLoading,
    onReloadProducts,
    onUpdateProducts,
  } = props;
  const history = useHistory();

  const queryParam = useQueryParam();
  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { mutate: syncImageAndBOM, isLoading: isSync } = useMutation(
    () => ProductApi.syncImageAndBOM({ pof_code: pof_code }),
    {
      onSuccess: (data: any) => {
        if (data.success == false) {
          openNotificationWithIcon('success', 'Không có cập nhật mới');
        } else {
          if (data.list_success && data.list_success.length > 0) {
            openNotificationWithIcon(
              'success',
              `Đã cập nhật thành công ${data.list_success.length} sản phẩm`
            );
            onReloadProducts();
          } else {
            openNotificationWithIcon('success', 'Không có cập nhật mới');
          }
        }
      },
      onError: (error: any) => {
        console.log(error);
        openNotificationWithIcon('error', 'Đồng bộ hình ảnh và BOM thất bại');
      },
    }
  );

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: 'Chỉnh sửa',
      icon: <img src={editDropdown} alt="" />,
    },
    {
      key: '2',
      label: 'Chuyển danh mục',
      icon: <img src={moveDropdown} alt="" />,
    },
    {
      key: '3',
      label: 'Ngừng hoạt động',
      icon: <img src={cancelDropdown} alt="" />,
    },
    {
      key: '4',
      label: 'Xoá sản phẩm',
      icon: <img src={cancelDropdown} alt="" />,
    },
  ];

  const columns: ColumnsType<IProduct> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 80,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Hình ảnh',
      render: (product: IProduct) => (
        <img style={{ height: 40 }} src={product.image_default} />
      ),
      width: 100,
    },
    {
      title: 'Mã basic (new)',
      dataIndex: 'basic_product',
      width: 250,
    },
    {
      title: 'Mã mẫu',
      dataIndex: 'pro_tpl_code',
      width: 177,
    },
    {
      title: 'Mã sản phẩm',
      dataIndex: 'product_code',
      width: 261,
    },
    {
      title: 'Tên sản phẩm',
      dataIndex: 'product_name',
      width: 261,
    },
    {
      title: 'Tên bộ sưu tập',
      dataIndex: 'bst_text',
      width: 261,
    },
    {
      title: 'Mã bộ',
      dataIndex: 'zma_bo',
      width: 150,
    },
    {
      title: 'Tên bộ',
      dataIndex: 'zma_bo_text',
      width: 261,
    },
    {
      title: 'Mã cặp',
      dataIndex: 'zma_ts_cap',
      width: 150,
    },
    {
      title: 'Tên cặp',
      dataIndex: 'zma_ts_cap_text',
      width: 261,
    },
    {
      title: 'Ngành hàng',
      width: 115,
      dataIndex: 'prod_grp2_name',
    },
    {
      title: 'Dòng hàng SAP',
      dataIndex: 'line_sap',
      width: 148,
    },
    {
      title: 'Dòng hàng Xman',
      dataIndex: 'line_xman_text',
      width: 200,
    },
    {
      title: 'Xman',
      dataIndex: 'xman',
      width: 200,
    },
    {
      title: 'Chủng loại',
      dataIndex: 'chungloai_text',
      width: 112,
    },
    {
      title: 'Giá vốn bình quân',
      dataIndex: 'cost_price',
      width: 185,
      align: 'right',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    {
      title: 'Giá bán',
      dataIndex: 'price',
      width: 135,
      align: 'right',
      render: (value: number) => {
        return <>{formatCurrencyVND(value)}</>;
      },
    },
    // {
    //   title: 'Giá vốn bình quân',
    //   dataIndex: 'phankhuc_kh_text',
    //   width: 157,
    //   align: 'right',
    // },
    {
      title: 'Phân khúc giá',
      dataIndex: 'phankhuc_gia',
      width: 157,
    },
    {
      title: 'Loại đá',
      dataIndex: 'loai_da',
      width: 124,
    },
    {
      title: 'Nhóm đá',
      dataIndex: 'nhom_da',
      width: 124,
    },
    {
      title: 'Aging',
      dataIndex: 'aging',
      width: 157,
    },
    {
      title: 'BST',
      dataIndex: 'bst_text',
      width: 150,
    },
    {
      title: 'Giới tính',
      dataIndex: 'gioitinh_text',
      width: 90,
    },
    {
      title: 'Material Type',
      dataIndex: 'product_type_code',
      width: 126,
    },
    {
      title: 'Tuổi vàng',
      dataIndex: 'purity_of_gold',
      width: 99,
    },
    {
      title: 'Màu sắc',
      dataIndex: 'mausac_text',
      width: 120,
    },
    {
      title: 'Size ổ hột',
      width: 99,
      render: (product: IProduct) => {
        return <>{product.ohot_kc || ''}</>;
      },
    },
    {
      title: 'Xplant Status',
      dataIndex: 'xplant_status',
      width: 125,
    },
    {
      title: 'Phân nhóm',
      dataIndex: 'phan_nhom',
      width: 204,
    },
    {
      title: 'Trạng thái mẫu',
      dataIndex: '',
      width: 135,
    },
    {
      title: 'Is_DMHHKN',
      dataIndex: 'is_dmhhkn',
      width: 115,
    },
    {
      title: 'PLHH',
      dataIndex: 'plhh',
      width: 114,
    },
    {
      title: 'Material (Mẫu đại diện)',
      dataIndex: 'mau_dai_dien',
      width: 200,
      render: (record: any) => {
        return <>{record?.toString()}</>;
      },
    },
    {
      title: 'Material Group',
      dataIndex: 'material_group',
      width: 134,
    },
    {
      title: 'PL ni => Khung ni chuẩn (hàng mới)',
      dataIndex: 'item_size',
      width: 270,
    },
    {
      title: 'DGTQ',
      dataIndex: 'kldg_3tc',
      width: 73,
    },
    {
      title: 'PL tình trạng theo dõi NLSX',
      dataIndex: '',
      width: 219,
    },
    {
      title: 'Danh mục cũ',
      dataIndex: '',
      width: 121,
    },
    {
      title: 'Danh mục',
      dataIndex: '',
      width: 114,
    },
    {
      title: 'Basic status',
      dataIndex: 'basic_status',
      width: 177,
    },
    {
      title: 'Trạng thái sản phẩm',
      width: 171,
      render: (product: IProduct) => (
        <span>
          {
            PRODUCT_POF_STATUS.find((item) => item.value === product.pof_status)
              ?.label
          }
        </span>
      ),
    },
    // {
    //   title: 'Vòng đời giỏ hàng hiện tại',
    //   width: '200px',
    // },
    // {
    //   title: 'Doanh thu 6 tháng gần nhất',
    //   dataIndex: 'doanhthu_6th',
    //   width: 210,
    // },
    {
      title: 'Doanh thu TB 1 tháng (VND)',
      align: 'right',
      dataIndex: 'doanhthu_tb_1th',
      width: 210,
    },
    {
      title: 'Trạng thái bán hàng',
      width: 168,
      render: (product: IProduct) => (
        <span>
          {PRODUCT_STATUS.find((item) => item.value === product.status)?.label}
        </span>
      ),
    },
    // {
    //   title: 'Tổng SL tồn hiện tại',
    //   align: 'right',
    //   dataIndex: 'tongsl_ton',
    //   width: 160,
    // },
    // {
    //   title: 'Tổng SL Tổng giá trị',
    //   align: 'right',
    //   dataIndex: 'tong_giatri',
    //   width: 160,
    // },
    {
      fixed: 'right',
      align: 'center',
      width: 100,
      render: () => (
        <div className="flex justify-around">
          <button>
            <EyeIcon />
          </button>
          <div>
            <Dropdown menu={{ items }} trigger={['click']}>
              <button onClick={(e) => e.preventDefault()}>
                <Space>
                  <MoreOption />
                </Space>
              </button>
            </Dropdown>
          </div>
        </div>
      ),
    },
  ];

  return (
    <Spin spinning={isSync}>
      <div className="flex justify-end gap-2">
        <Button
          disabled={pof_type_code == 'suggest'}
          bgColor={'bg-white'}
          color={'text-primary-50'}
          border={'border-primary-50'}
          onClick={syncImageAndBOM}
        >
          Lấy hình ảnh và BOM
        </Button>
        <Button
          onClick={() => {
            onUpdateProducts();
          }}
        >
          <UploadIcon /> Cập nhật sản phẩm
        </Button>
      </div>
      <Content className="main-content" style={{ padding: '10px 0px 0px' }}>
        <Table
          rowKey={(record) => record.id}
          className="customTable"
          size="small"
          columns={columns}
          dataSource={products}
          scroll={{ x: 970 }}
          loading={isLoading}
          pagination={{
            className: 'flex items-center',
            current: page,
            pageSize: page_size,
            total: total,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
            onChange: HocChangePagination(history),
          }}
        />
      </Content>
    </Spin>
  );
}
